/**
 * URL query helpers: ?add_to_cart=VARIANT_ID,VARIANT_ID (comma-separated, max 4)
 * and ?cart_opened=true to open the cart drawer after add (or alone).
 * Cleans params from the address bar after handling via history.replaceState.
 *
 * Do not call cart-items / cart-drawer-items onCartUpdate() here: that fetches
 * section cart__main and replaces drawer markup, which races with renderContents()
 * and duplicates "My Cart" / breaks layout. Match ProductMain: publish → renderContents → open.
 */
(function () {
  var params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (_) {
    return;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('#CartDrawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  function onReady(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  /** @param {string|null} raw */
  function parseVariantIds(raw) {
    if (!raw || typeof raw !== 'string') return [];
    var seen = {};
    var out = [];
    var parts = raw.split(',');
    for (var i = 0; i < parts.length && out.length < 4; i++) {
      var id = parseInt(String(parts[i]).trim(), 10);
      if (!(id > 0) || !isFinite(id) || seen[id]) continue;
      seen[id] = true;
      out.push(id);
    }
    return out;
  }

  function stripParamsFromUrl() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('add_to_cart') && !url.searchParams.has('cart_opened')) return;
      url.searchParams.delete('add_to_cart');
      url.searchParams.delete('cart_opened');
      history.replaceState({}, '', url.pathname + (url.search || '') + url.hash);
    } catch (_) {}
  }

  var addToCartParam = params.get('add_to_cart');
  var cartOpened = params.get('cart_opened') === 'true';
  var variantIds = parseVariantIds(addToCartParam);

  if (variantIds.length) {
    onReady(function () {
      var cartDrawer = document.querySelector('cart-drawer');
      var cartAddUrl =
        (window.routes && window.routes.cart_add_url) ||
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + 'cart/add.js');

      if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') {
        if (cartOpened) openCartDrawer();
        stripParamsFromUrl();
        return;
      }

      var items = variantIds.map(function (id) {
        return { id: id, quantity: 1 };
      });
      var sectionIds = cartDrawer.getSectionsToRender().map(function (s) {
        return s.id;
      });

      fetch(String(cartAddUrl), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: items,
          sections: sectionIds,
          sections_url: window.location.pathname,
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data && data.status) {
            if (window.theme && theme.utils && theme.utils.subscriptions) {
              theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartError, {
                source: 'url-params-add-to-cart',
                errors: data.errors || data.description,
                message: data.message,
              });
            }
            if (cartOpened) openCartDrawer();
            stripParamsFromUrl();
            return;
          }
          if (data && data.message === 'Cart Error') {
            if (cartOpened) openCartDrawer();
            stripParamsFromUrl();
            return;
          }
          if (window.theme && theme.utils && theme.utils.subscriptions) {
            theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'url-params-add-to-cart',
            });
          }
          cartDrawer.renderContents(data);
          openCartDrawer();
          stripParamsFromUrl();
        })
        .catch(function (err) {
          console.warn(err);
          if (cartOpened) openCartDrawer();
          stripParamsFromUrl();
        });
    });
    return;
  }

  if (cartOpened) {
    onReady(function () {
      openCartDrawer();
      stripParamsFromUrl();
    });
  }
})();
